import { ISelectType } from "@4uhub/lib4uhub";

export type TRestrictionTypeField =
  | {
    id?: string;
    name?: string;
    code?: string | number | null;
    value?: string | number | null;
  }
  | ISelectType
  | string
  | number
  | null
  | undefined;

export const TICKET_DEFAULT_DOC_RESTRICTION_TYPE = {
  WORKSPACE: "1",
  CHANNEL: "2",
} as const;

export const getRestrictionTypeCode = (value: TRestrictionTypeField) =>
  typeof value === "object" && value
    ? String(value.code ?? value.value ?? value.name ?? "")
    : String(value ?? "");

export const isWorkspaceRestrictionType = (value: TRestrictionTypeField) => {
  const code = getRestrictionTypeCode(value).toLowerCase();
  return (
    code === TICKET_DEFAULT_DOC_RESTRICTION_TYPE.WORKSPACE ||
    code === "workspace"
  );
};

export const isChannelRestrictionType = (value: TRestrictionTypeField) => {
  const code = getRestrictionTypeCode(value).toLowerCase();
  return (
    code === TICKET_DEFAULT_DOC_RESTRICTION_TYPE.CHANNEL || code === "channel"
  );
};

export const getRestrictionTypeValue = (value: TRestrictionTypeField) => {
  if (isWorkspaceRestrictionType(value)) {
    return Number(TICKET_DEFAULT_DOC_RESTRICTION_TYPE.WORKSPACE);
  }
  if (isChannelRestrictionType(value)) {
    return Number(TICKET_DEFAULT_DOC_RESTRICTION_TYPE.CHANNEL);
  }
  const code = getRestrictionTypeCode(value);
  const numericCode = Number(code);
  return Number.isNaN(numericCode) ? code : numericCode;
};

export const buildRestrictionTypeOption = (value: TRestrictionTypeField) => {
  if (isWorkspaceRestrictionType(value)) {
    return TICKET_DEFAULT_DOC_RESTRICTION_TYPE.WORKSPACE;
  }
  if (isChannelRestrictionType(value)) {
    return TICKET_DEFAULT_DOC_RESTRICTION_TYPE.CHANNEL;
  }
  return value ? String(value) : "";
};
